
export const mercure_url = process.env.MERCURE_URL
export const api_url = `${process.env.API_APP_URL}/api`
export const app_env = process.env.APP_ENV
export const default_api_token = "screen:zhharV62E2"
export const tokenId = 'screen_uniq_id';
export const last_refresh_day = 'last_refresh_day';
export const root_rotate = 'root_rotate';
export const screenToken = 'screen_token_api';
export const front_url = process.env.FRONT_URL;
export const sentry_key = process.env.SENTRY;
